import script from "./articleView.vue?vue&type=script&setup=true&lang=js"
export * from "./articleView.vue?vue&type=script&setup=true&lang=js"

import "./articleView.vue?vue&type=style&index=0&id=3f1c6c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f1c6c3a"]])

export default __exports__